import { api } from '../client';

export const fetchHeader = async () => {
  const { data } = await api.get('/header');
  return data;
};
